module.exports = __webpack_public_path__ + "img/ofituria.f4c9e502.png";